import { render, staticRenderFns } from "./ChannelProduct.vue?vue&type=template&id=37d811de&scoped=true&"
import script from "./ChannelProduct.vue?vue&type=script&lang=js&"
export * from "./ChannelProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChannelProduct.vue?vue&type=style&index=0&id=37d811de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d811de",
  null
  
)

export default component.exports